import type { MagazineAnalyticsSetting_DesignPageQuery } from "@/lib/gql/__generated__/graphql";

import { useCreateMagazineAnalyticsSettingFormModel } from "../use-create-model";

type Props = {
	serverModel: MagazineAnalyticsSetting_DesignPageQuery;
};

export const useInitialized = ({ serverModel }: Props) => {
	return {
		...useCreateMagazineAnalyticsSettingFormModel({ serverModel: serverModel }),
	};
};
